import React from "react";
import i18n from "../lib/i18n";
import { Dropdown } from "react-bootstrap";

const ChartSelector = ({ tabs, activeTab, setActiveTab, intercomTarget }) => {
  return (
    <div className="flex align-items-center">
      <p className="mb-0 mr-16 fw-medium">
        {i18n.t("js.components.chart_selector.choose_graph")}
      </p>
      <Dropdown>
        <Dropdown.Toggle
          className="react-dropdownbtn"
          variant=""
          id="dropdown-basic"
          data-intercom-target={intercomTarget}
        >
          {tabs.find((tab) => tab.key === activeTab).label}
        </Dropdown.Toggle>
        <Dropdown.Menu className="react-dropdownmenu">
          {tabs.map((tab) => (
            <Dropdown.Item
              as="li"
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              active={activeTab === tab.key}
            >
              {tab.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default ChartSelector;
